import Vue from 'vue';

let instance;

export const useBreakpointsObserver = ({
  breakpoints = {}
}) => {
  if (instance) return instance;

  instance = new Vue({
    data() {
      return {
        breakpoints: breakpoints,
        windowWidth: window.innerWidth,
      }
    },
    computed: {
      isLgOrLess() {
        return this.windowWidth <= this.breakpoints.lg
      },
      isMdOrLess() {
        return this.windowWidth <= this.breakpoints.md
      }
    },
    created() {
      window.addEventListener('resize', this.onResize)
    },
    methods: {
      onResize() {
        this.windowWidth = window.innerWidth
      }
    }
  });

  return instance;
}

export const BreakpointsObserverPlugin = {
  install(Vue, options) {
    Vue.prototype.$bp = useBreakpointsObserver(options)
  }
}

export default BreakpointsObserverPlugin;
